var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"domaine-card"},[_vm._t("icon"),_c('h2',[_vm._t("title")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }